import Header from "../../components/Header";
import HeroSection from "./HeroSection";
import ProductSection from "./ProductSection";

function Home() {
  return (
    <>
      <Header variant="default" />
      <HeroSection />
      <ProductSection />
    </>
  );
}

export default Home;
